import { Component, Vue } from 'vue-property-decorator';
import { RawLocation, Route } from 'vue-router';
import { Mutation, State } from 'vuex-class';

@Component({})
export default class AppSessieAfgesloten extends Vue {
  @State(state => state.config.ppfWebsiteUrl)
  public ppfWebsiteUrl!: string;
  @State(state => state.sessionSuspended.lastUrl)
  public lastUrl!: string;
  @Mutation('sessionSuspended/storeLastUrl')
  private storeLastUrl!: (lastUrl?: string) => void;

  public get loginRoute(): RawLocation {
    return this.lastUrl || { name: 'hypotheek' };
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.storeLastUrl();
    next();
  }
}
